import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Registrá las unidades de medida que usás para tus repuestos y consumibles: unidad, litro, kit, tambor, kg, etc.',
    'La abreviatura es opcional y se usa para mostrar la unidad de forma compacta en listados e informes.',
  ],
  nextSteps: [
    'Asignar la unidad de medida a cada repuesto del catálogo.',
    'También podés crear una unidad nueva desde el propio formulario de repuestos, con el botón "+".',
  ],
};

const ConfiguracionUnidadesMedida = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="unidades-medida"
      titulo="Unidades de Medida"
      descripcion="Unidades de medida de repuestos y consumibles"
      icon="fas fa-balance-scale"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionUnidadesMedida;
